/* eslint-disable no-irregular-whitespace */
import {commonPromise} from '../../http'
import {
    COURSE_LIST,
    SMS_SEND,
    SMS_LOGIN,
    WECHAT_LOGIN,
    DETAIL_GET,
    WECHAT_CONFIG,
    UPDATE_LOGIN,
    SHARE,
    SHARE_SUCCESS,
    GET_SHARE_IMG_URL,
    SHARE_CONTENT,
    JAVA_GET_CODE,
    JAVA_SEND_CODE,
    JAVA_GET_IMG,
    JAVA_GET_LENGHT,
    JAVA_GET_PHONE,
    PUBLISH_STATE
} from '../global'

export const courseListFetch = (data) => commonPromise(data, COURSE_LIST);// 课程列表
export const SMSsend = (data) => commonPromise(data, SMS_SEND);// 发送短信验证码
export const SMSlogin = (data) => commonPromise(data, SMS_LOGIN, 'post');// 发送短信验证码
export const wechatLogin = (data) => commonPromise(data, WECHAT_LOGIN, 'post');// 微信授权登陆
export const updateLogin = (data) => commonPromise(data, UPDATE_LOGIN, 'post');// 用户更新

export const detailFetch = (data) => commonPromise(data, DETAIL_GET);// 详情外链
export const share = (data) => commonPromise(data, SHARE);// 分享
export const shareSuccess = (data) => commonPromise(data, SHARE_SUCCESS);// 分享成功
export const wxConfig = (data) => commonPromise(data, WECHAT_CONFIG);// 微信JSDK

export const getShareImgUrl = (data) => commonPromise(data, GET_SHARE_IMG_URL);// 微信JSDK

export const shareContent = (data) => commonPromise(data, SHARE_CONTENT);// 新增微信分享文案
export const SendCode = (data) => commonPromise(data, JAVA_GET_CODE);// 发送短信验证码
export const SubmitCode = (data) => commonPromise(data, JAVA_SEND_CODE);// 发送短信验证码
export const SubmitImg = (data) => commonPromise(data, JAVA_GET_IMG);// 获取验证图片
export const SubmitImgLenght = (data) => commonPromise(data, JAVA_GET_LENGHT);// 提交滑块滑动距离
export const GetPhone = (data) => commonPromise(data, JAVA_GET_PHONE);// 提交滑块滑动距离







// WEBPACK FOOTER //
// ./src/api/apiModules/baseApi.js